export default "__VITE_ASSET__Bcxj0LTk__"